import { Editor, Transforms } from 'slate';
import { isCodeSnippetActive } from './utils';
import {
  type EditorPlugin,
  type MarkdownData,
} from '../../../types/aha-editor';
import CodeSnippetComponentPlugin from './CodeSnippetComponentPlugin';
import { markRegexp } from '../../Markdown/Utils';
import Markdown from '../../Markdown/Markdown';
import { isCodeSnippetElement } from '../../../types/guards';
import NodeUtils from '../../../AhaEditorUtils/NodeUtils';

const isNotInCodeSnippet = (editor: Editor): boolean => {
  return !isCodeSnippetActive(editor);
};

const convert = (editor: Editor, markdownOptions: MarkdownData): void => {
  const { matchData, triggerKey } = markdownOptions;

  Editor.insertNode(editor, {
    type: 'code-snippet',
    children: [{ text: matchData[2] }],
  });
  Editor.insertNode(editor, {
    text: '',
  });
  Transforms.move(editor, { unit: 'offset' });

  if (triggerKey.length > 0) {
    Editor.insertText(editor, triggerKey);
  }
};

const revert = (editor: Editor): void => {
  const { selection } = editor;
  if (!selection) return;

  const codeSnippet = NodeUtils.previousSibling(editor, selection.anchor.path, {
    match: isCodeSnippetElement,
  });

  if (codeSnippet) {
    Transforms.removeNodes(editor, {
      at: codeSnippet[1],
    });
    Transforms.delete(editor, {
      distance: 1,
      unit: 'character',
      reverse: true,
    });
  }
};

export const CodeSnippetMarkdownPlugin: EditorPlugin = {
  name: 'Code snippet markdown plugin',
  dependencies: [Markdown, CodeSnippetComponentPlugin],
  markdown: [
    {
      type: 'inline',
      shortcut: markRegexp('`'),
      convert,
      shiftTabRevert: false,
      ignoreUncaptured: true,
      revert,
      test: isNotInCodeSnippet,
    },
  ],
};

export default CodeSnippetMarkdownPlugin;
